/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SimulationTask } from '../../models/simulation-task';

export interface SimulationTasksFinishedGet$Params {
}

export function simulationTasksFinishedGet(http: HttpClient, rootUrl: string, params?: SimulationTasksFinishedGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SimulationTask>>> {
  const rb = new RequestBuilder(rootUrl, simulationTasksFinishedGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SimulationTask>>;
    })
  );
}

simulationTasksFinishedGet.PATH = '/simulation-tasks/finished';
